import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { EntityChip } from "./EntityChip";
export const ChipList = ({ objects, className, objectToName, sx, objectToChipProps, onDeleteObject, renderChip, }) => {
    return (_jsx(Box, { sx: sx, className: className, children: objects.map(obj => renderChip ? (renderChip(obj)) : (_jsx(EntityChip, { label: objectToName(obj), onDelete: onDeleteObject
                ? () => {
                    onDeleteObject(obj);
                }
                : undefined, chipProps: objectToChipProps ? objectToChipProps(obj) : {} }, obj.id))) }));
};
//# sourceMappingURL=index.js.map